(function () {
  function normalizeString(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s]/g, '')
      .trim()
      .toLowerCase();
  }

  function buildAvailabilityMap(variantAvailabilities) {
    const map = new Map();
    (variantAvailabilities || []).forEach((item) => {
      const names = [item.location_name].filter(Boolean);
      names.forEach((name) => {
        map.set(normalizeString(name), item);
      });
    });
    return map;
  }

  function resolveStoreAvailability(store, availabilityMap) {
    const possibleKeys = [store.name].concat(store.match || []);
    for (const key of possibleKeys) {
      const found = availabilityMap.get(normalizeString(key));
      if (found) return found;
    }
    return null;
  }

  function createMarkerIcon(isAvailable) {
    return L.icon({
      iconUrl: isAvailable
        ? 'https://cdn.shopify.com/s/files/1/0285/4240/2594/files/marker-icon.png?v=1775813138'
        : 'https://cdn.shopify.com/s/files/1/0285/4240/2594/files/marker-icon-selected.png?v=1775813367',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -41]
    });
  }

  class PickupStoreModal {
    constructor(root) {
      this.root = root;

      this.currentVariantId = null;

      // prende variante iniziale
      const initialVariantInput = document.querySelector('input[name="id"], select[name="id"]');
      if (initialVariantInput) {
        this.currentVariantId = initialVariantInput.value;
      }
      // Il pulsante di apertura è dentro il wrapper (root)
      this.openBtn = root.querySelector('[data-open-pickup-modal]');

      // Il modal è stato spostato su <body> dall'inline script nel liquid,
      // quindi lo cerchiamo per ID nel documento, non nel root.
      const modalId = this.openBtn ? this.openBtn.getAttribute('aria-controls') : null;
      this.modal = (modalId && document.getElementById(modalId)) || root.querySelector('.pickup-store-modal');

      if (!this.modal) return;

      // Tutti gli elementi interni sono dentro il modal, non nel root
      this.closeBtns      = this.modal.querySelectorAll('[data-close-pickup-modal]');
      this.searchInput    = this.modal.querySelector('[data-store-search]');
      this.countEl        = this.modal.querySelector('[data-store-count]');
      this.listEl         = this.modal.querySelector('[data-store-list]');
      this.mapEl          = this.modal.querySelector('[data-store-map]');

      // I JSON data rimangono dentro il modal
      this.masterStores          = this.readJson('[data-store-master-json]');
      this.variantAvailabilities = this.readJson('[data-variant-availability-json]');

      this.markers      = [];
      this.activeKey    = null;
      this.map          = null;
      this.currentStores = [];

      this.handleEsc = this.handleEsc.bind(this);

      this.bind();
      this.bindVariantChange();
    }

    readJson(selector) {
      const node = this.modal.querySelector(selector);
      if (!node) return [];
      try {
        return JSON.parse(node.textContent.trim());
      } catch (e) {
        console.error('Pickup modal JSON parse error', e);
        return [];
      }
    }

    bind() {
      if (this.openBtn) {
        this.openBtn.addEventListener('click', () => this.open());
      }

      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.render());
      }
    }

    bindVariantChange() {
      document.addEventListener('change', (event) => {
        const variantInput = event.target.closest('input[name="id"], select[name="id"]');
        if (!variantInput) return;

        const variantId = variantInput.value;
        if (variantId) {
          this.currentVariantId = variantId;
          this.fetchVariantAvailability(variantId);
        }
      });

      document.addEventListener('variant:change', (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant && variant.id) {
          this.currentVariantId = variant.id;
          this.fetchVariantAvailability(variant.id);
        }
      });
    }

async fetchVariantAvailability(variantId) {
  const productHandle = this.root.dataset.productHandle;
  if (!productHandle || !variantId) return;

  try {
    const url = `/products/${productHandle}?variant=${variantId}&view=pickup-availability-json`;
    const response = await fetch(url);
    if (!response.ok) return;
    const data = await response.json();
    if (!data || !Array.isArray(data.availabilities)) return;

    this.variantAvailabilities = data.availabilities;

    if (!this.modal.hidden) {
      this.render();
    }
  } catch (error) {
    console.error('Pickup availability refresh error:', error);
  }
}

    open() {
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      this.openBtn && this.openBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.handleEsc);

      setTimeout(() => {
        this.initMap();
        this.render();
        if (this.map) this.map.invalidateSize();
      }, 20);
    }

    close() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
      this.openBtn && this.openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.handleEsc);
    }

    handleEsc(event) {
      if (event.key === 'Escape') this.close();
    }

    initMap() {
      if (this.map || !this.mapEl || typeof L === 'undefined') return;
      this.map = L.map(this.mapEl).setView([41.9440357, 12.1822743], 10);
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap'
      }).addTo(this.map);
    }

getMergedStores() {
  const availabilityMap = buildAvailabilityMap(this.variantAvailabilities);
  return this.masterStores.map((store) => {
    const availability = resolveStoreAvailability(store, availabilityMap);
    return {
      ...store,
      available: !!(availability && availability.available),
      pickUpTime: availability && availability.pick_up_time ? availability.pick_up_time : null,
      availabilityRaw: availability
    };
  }).sort((a, b) => {
    if (a.available && !b.available) return -1;
    if (!a.available && b.available) return 1;
    return 0;
  });
}

    getFilteredStores() {
      const query = normalizeString(this.searchInput ? this.searchInput.value : '');
      const stores = this.getMergedStores();
      if (!query) return stores;
      return stores.filter((store) => {
        const haystack = normalizeString(
          [store.name, (store.match || []).join(' '), store.address_html.replace(/<br\s*\/?>/gi, ' ')].join(' ')
        );
        return haystack.includes(query);
      });
    }

    updateCount(stores) {
      if (!this.countEl) return;
      const available = (stores || []).filter((s) => s.available).length;
      if (available === 0)      this.countEl.textContent = 'Nessun negozio trovato';
      else if (available === 1) this.countEl.textContent = '1 negozio trovato';
      else                      this.countEl.textContent = `${available} negozi trovati`;
    }

    clearMarkers() {
      this.markers.forEach((m) => m.remove());
      this.markers = [];
    }

    renderMap(stores) {
      if (!this.map) return;
      this.clearMarkers();

      if (!stores.length) {
        this.map.setView([41.9440357, 12.1822743], 10);
        return;
      }

      const bounds = [];
      stores.forEach((store) => {
        const marker = L.marker([store.lat, store.lng], { icon: createMarkerIcon(store.available) }).addTo(this.map);
        marker.bindPopup(`
          <div class="pickup-map-popup">
            <div class="pickup-map-popup__title">${store.name}</div>
            <div class="pickup-map-popup__status ${store.available ? 'is-available' : 'is-unavailable'}">
              <span class="pickup-map-popup__dot"></span>
              <span>${store.available
                ? `Disponibile${store.pickUpTime ? ` - ${store.pickUpTime.charAt(0).toUpperCase() + store.pickUpTime.slice(1)}` : ''}`
                : 'Non disponibile'}</span>
            </div>
            <div class="pickup-map-popup__address">${store.address_html}</div>
            <div class="pickup-map-popup__actions">
              <a href="${store.directions_url}" target="_blank" rel="noopener">Ottieni indicazioni</a>
            </div>
          </div>
        `);
        marker.on('click', () => this.highlightStore(store.key));
        this.markers.push(marker);
        bounds.push([store.lat, store.lng]);
      });

      if (bounds.length === 1) {
        this.map.setView(bounds[0], 12);
      } else {
        this.map.fitBounds(bounds, { padding: [40, 40] });
      }
    }

    highlightStore(storeKey) {
      this.activeKey = storeKey;
      this.listEl.querySelectorAll('.pickup-store-item').forEach((item) => {
        item.classList.toggle('is-active', item.dataset.storeKey === storeKey);
      });
      const store = this.currentStores.find((s) => s.key === storeKey);
      if (!store || !this.map) return;
      this.map.setView([store.lat, store.lng], 12);
      const markerIndex = this.currentStores.findIndex((s) => s.key === storeKey);
      if (this.markers[markerIndex]) this.markers[markerIndex].openPopup();
    }

    renderList(stores) {
      if (!stores.length) {
        this.listEl.innerHTML = `<div class="pickup-store-empty">Nessun negozio trovato.</div>`;
        return;
      }

      this.listEl.innerHTML = stores.map((store) => {
        const statusClass = store.available ? 'pickup-store-status--available' : 'pickup-store-status--unavailable';
        const statusText  = store.available
          ? `Disponibile${store.pickUpTime ? `, ${store.pickUpTime.toLowerCase()}` : ''}`
          : 'Non disponibile in questo negozio';

        return `
          <div class="pickup-store-item" data-store-key="${store.key}">
            <div class="pickup-store-item__top">
              <div>
                <div class="pickup-store-item__title">${store.name}</div>
                <div class="pickup-store-status ${statusClass}">
                  <span class="pickup-store-status__dot"></span>
                  <span>${statusText}</span>
                </div>
              </div>
            </div>
            <div class="pickup-store-item__address">${store.address_html}</div>
            <div class="pickup-store-item__hours">${store.hours_html}</div>
            <div class="pickup-store-item__actions">
              <button type="button" class="pickup-store-link" data-show-on-map="${store.key}">Mostra sulla mappa</button>
              <a class="pickup-store-link" href="${store.directions_url}" target="_blank" rel="noopener">
                Ottieni indicazioni
                <svg width="10" height="10" viewBox="0 0 24 24" style="margin-left:4px;" aria-hidden="true">
                  <path d="M3.65 20.35V3.65h7.86v1.39H5.04v13.91h13.91v-6.47h1.39v7.86H3.65zm6.08-5.08l-.97-1 9.23-9.23h-5.08V3.65h7.44v7.44h-1.39V6.03l-9.23 9.23z"/>
                </svg>
              </a>
              ${store.available && this.currentVariantId ? `
              <a href="/cart/${this.currentVariantId}:1?checkout" class="pickup-store-link">
                Acquista e ritira
                <svg width="10" height="10" viewBox="0 0 24 24" style="margin-left:4px;" aria-hidden="true">
                  <path d="M3.65 20.35V3.65h7.86v1.39H5.04v13.91h13.91v-6.47h1.39v7.86H3.65zm6.08-5.08l-.97-1 9.23-9.23h-5.08V3.65h7.44v7.44h-1.39V6.03l-9.23 9.23z"/>
                </svg>
              </a>
            ` : ''}
            </div>
          </div>
        `;
      }).join('');

      this.listEl.querySelectorAll('[data-show-on-map]').forEach((btn) => {
        btn.addEventListener('click', () => this.highlightStore(btn.dataset.showOnMap));
      });

      const firstKey = this.activeKey && stores.some((s) => s.key === this.activeKey)
        ? this.activeKey
        : stores[0].key;
      this.highlightStore(firstKey);
    }

    render() {
      this.currentStores = this.getFilteredStores();
      this.updateCount(this.currentStores);
      this.renderList(this.currentStores);
      this.renderMap(this.currentStores);
    }
  }

  function initAllPickupStoreModals() {
    document.querySelectorAll('[data-pickup-store-modal-root]').forEach((root) => {
      if (root.dataset.pickupStoreModalInitialized === 'true') return;
      root.dataset.pickupStoreModalInitialized = 'true';
      new PickupStoreModal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPickupStoreModals);
  } else {
    initAllPickupStoreModals();
  }
})();
